import { makeStyles, Box, TextField, Button, MenuItem, Checkbox } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import UniDialog from '../../../Common/UniDialog';
import { getUserPreference, handleTextualizeDriverNameAndVehicleType } from '../../../../utilities/common';
import { useEffect, useState } from "react";
import { getLetianStaffTemp, quickTransferOrders } from "../../../../actions/qtActions";
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';
import { handleEditOrderModal, showAlertSnackbar } from "../../../../reducers/uiSlice";
import { getOrdersByDriverCriteria, handleReturnScan } from "../../../../actions/ddActions";
import FullscreenLoading from "../../../Common/FullscreenLoading";

const useStyles = makeStyles((theme) => ({
    root: {
        // height: '95vh'
    },
    flexGroup: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 20
    },
    item: {
        width: '48.5%'
    },
    itemBox: {
        marginTop: 10,
        border: '1px #707070 solid',
        height: '65vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    groupBox: {
        overflow: 'scroll',
        height: '55vh',
        paddingTop: 14,
        paddingRight: 24,
        paddingBottom: 14,
    },
    itemInputBox: {
        height: '10vh',
        borderTop: '1px #707070 solid',
        paddingLeft: 40,
        paddingTop: 14,
        paddingRight: 40,
        paddingBottom: 14,
        display: 'flex',
        alignItems: 'center'
    },
    menuItemStyle: {
        display: 'flex',
        alignItems: 'center'
    },
    notesGroupStyle: {
        display: 'flex',
        alignItems: 'baseline',
        marginLeft: 40
    },
    notesStyle: {
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        maxWidth: 600
    }
}));

function ReturnedPackages(props) {
    const classes = useStyles();
    const { t } = useTranslation('driverDispatch');
    const userPref = getUserPreference();
    const dispatch = useDispatch();

    const searchList = useSelector(state => state.ddReducer.getLetianStaff);

    const [transferDriverName, setTransferDriverName] = useState('');
    const [transferDriverId, setTransferDriverId] = useState();
    const [driverListTemp, setDriverListTemp] = useState([]);
    const [oughtList, setOughtList] = useState([]);
    const [returnedList, setReturnedList] = useState([]);
    const [list, setList] = useState();
    const [tno, setTno] = useState('');
    const [loading, setLoading] = useState(false);
    const [allChecked, setAllChecked] = useState(false);
    const [checked, setChecked] = useState({});

    const handleSubmit = async () => {
        try {
            let tnos = [];
            for (const key in checked) {
                if (checked[key]) {
                    tnos.push(key);
                }
            }
            setLoading(true);
            let params = {
                tnos: tnos.toString(),
                driver_id: transferDriverId,
                operator: userPref.username
            }
            let res = await dispatch(quickTransferOrders(params))
            if (res.order_not_found.length === 0) {
                await dispatch(showAlertSnackbar({
                    title: "Transferred Successful!",
                    message: `All ${res.success.length} orders are transferred`,
                    type: 'success'
                }))
            } else {
                await dispatch(showAlertSnackbar({
                    title: "Transferred Partially Successful!",
                    message: `Failed: ${res.order_not_found}`,
                    type: 'warning'
                }))
            }
            let refreshParams = {
                criteria: 'RETURNED',
                scan_batch_id: props.batchId
            }
            let resRefresh = await dispatch(getOrdersByDriverCriteria(refreshParams))
            await setList(resRefresh);
            await setTransferDriverId('');
            await setTransferDriverName('...');
            await setTno('');
        } catch {
            dispatch(showAlertSnackbar({
                message: t('transfer_or_fetch_res_failed'),
                type: 'error'
            }))
        } finally {
            setAllChecked(false);
            setChecked({});
            setLoading(false);
        }
    }

    const toggleChecked = (tno) => {
        let clone = { ...checked };
        clone[tno] = !checked[tno];
        setChecked(clone);
    }

    const handleEditOrderModalOpen = (tno) => {
        dispatch(handleEditOrderModal({ open: true, orderIdentifier: tno, type: "tno" }));
    }

    const handleKeyUp = async (e) => {
        if (e.keyCode === 13) {
            try {
                setLoading(true);
                await dispatch(handleReturnScan(props.batchId, tno, userPref.username))
                setTno('');
                let params = {
                    criteria: 'RETURNED',
                    scan_batch_id: props.batchId
                }
                let resRefresh = await dispatch(getOrdersByDriverCriteria(params))
                setList(resRefresh);
                await dispatch(showAlertSnackbar({ message: t('return_success'), type: 'success' }))
            } catch {
                dispatch(showAlertSnackbar({ message: t('fail_detail'), type: 'error' }))
            } finally {
                setLoading(false);
            }
        }
    }

    useEffect(() => {
        setList(props.list);
    }, [props.list])

    useEffect(() => {
        if (props.open) {
            setOughtList([]);
            setReturnedList([]);
            if (list?.length > 0) {
                _.filter(list, (order) => {
                    if (order.scaned_item_status === 2) {
                        setOughtList((prev) => [
                            ...prev,
                            order
                        ])
                    } else if (order.scaned_item_status === 6) {
                        setChecked((prev) => ({
                            ...prev,
                            [order.extra_order_sn]: false
                        }))
                        setReturnedList((prev) => [
                            ...prev,
                            order
                        ])
                    }
                })
            } else {
                setOughtList([]);
                setReturnedList([]);
            }
        }
    }, [list, props.open])

    useEffect(() => {
        if (props.open) {
            setTransferDriverName('...');
            if (userPref.userCity === 2 || userPref.userCity === 14) {
                dispatch(getLetianStaffTemp(userPref.userCity))
                    .then((res) => {
                        setDriverListTemp(res);
                    })
            }
        } else {
            setTransferDriverName('...');
        }
    }, [props.open])

    useEffect(() => {
        let clone = { ...checked };
        for (const tno in clone) {
            clone[tno] = allChecked;
        }
        setChecked(clone);
    }, [allChecked])

    return (
        <UniDialog
            className={classes.root}
            open={props.open}
            title={t('returned_packages_title')}
            onBackdropClick={false}
            onClose={() => {
                props.handleClose()
            }}
            maxWidth='lg'
            fullWidth
            disableDefaultButtons
        >
            <Box className={classes.flexGroup}>
                <Box className={classes.item}>
                    <Box>{t('packages_not_returned')}</Box>
                    <Box className={classes.itemBox}>
                        <Box className={classes.groupBox}>
                            {
                                oughtList?.length > 0 &&
                                oughtList.map((order, index) => (
                                    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                                        <MenuItem
                                            value={order.extra_order_sn || order.tno}
                                            key={index}
                                            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                                        >
                                            <div
                                                className={classes.menuItemStyle}
                                            >
                                                {order.extra_order_sn}
                                            </div>
                                            {
                                                order?.driver_notes &&
                                                <div
                                                    className={classes.notesGroupStyle}
                                                >
                                                    <div className={classes.notesStyle}>
                                                        {order.driver_notes}
                                                    </div>
                                                </div>
                                            }
                                        </MenuItem>
                                        <Button
                                            color="secondary"
                                            onClick={() => {
                                                handleEditOrderModalOpen(order.extra_order_sn)
                                            }}
                                            style={{ marginTop: 10 }}
                                        >
                                            {t('edit')}
                                        </Button>
                                    </div>
                                ))
                            }
                        </Box>
                        <Box className={classes.itemInputBox}>
                            <div style={{ width: '100%' }}>
                                <Box style={{ marginBottom: 10 }}>{t('scan')}</Box>
                                <Box>
                                    <TextField
                                        fullWidth
                                        label={t('current_scan')}
                                        variant="outlined"
                                        onKeyUp={(e) => handleKeyUp(e)}
                                        onChange={(e) => {
                                            setTno(e.target.value)
                                        }}
                                        value={tno}
                                    />
                                </Box>
                            </div>
                        </Box>
                    </Box>
                </Box>
                <Box className={classes.item}>
                    <Box>{t('packages_returned')}</Box>
                    <Box className={classes.itemBox}>
                        <Box className={classes.groupBox}>
                            {
                                returnedList?.length > 0 &&
                                <div style={{ display: 'flex', alignItems: 'space-between' }}>
                                    <MenuItem
                                        onClick={() => setAllChecked(!allChecked)}
                                    >
                                        <Checkbox
                                            checked={allChecked}
                                        ></Checkbox>
                                        <span>{t('select_all')}</span>
                                    </MenuItem>
                                </div>
                            }
                            {
                                returnedList?.length > 0 &&
                                returnedList.map((order, index) => {
                                    return (
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <div
                                                style={{ display: 'flex', justifyContent: 'space-between', width: '65%' }}
                                            >
                                                <MenuItem
                                                    value={order.extra_order_sn}
                                                    key={index}
                                                    onClick={() => toggleChecked(order.extra_order_sn)}
                                                    style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'flex-start' }}
                                                >
                                                    <div
                                                        className={classes.menuItemStyle}
                                                    >
                                                        <Checkbox
                                                            key={index}
                                                            checked={checked[order.extra_order_sn]}
                                                            id={`driverdispatch-drivertransfer-return-checkbox-${index}`}
                                                        >
                                                        </Checkbox>
                                                        <div
                                                            style={order.state === 203 ? { backgroundColor: 'green' } : (order.state === 202 ? { backgroundColor: 'orange' } : { backgroundColor: 'transparent' })}
                                                        >
                                                            <div>{order.extra_order_sn}</div>
                                                        </div>
                                                    </div>
                                                    {
                                                        order?.driver_notes &&
                                                        <div
                                                            className={classes.notesGroupStyle}
                                                        >
                                                            <div className={classes.notesStyle}>
                                                                {order.driver_notes}
                                                            </div>
                                                        </div>
                                                    }
                                                </MenuItem>
                                                <Button
                                                    color="secondary"
                                                    onClick={() => {
                                                        handleEditOrderModalOpen(order.extra_order_sn)
                                                    }}
                                                    style={{ marginTop: 10 }}
                                                >
                                                    {t('edit')}
                                                </Button>
                                            </div>
                                            <div>
                                                <div>{t('last_operator')}{order.last_operator}</div>
                                                <div style={{
                                                    color: 'rgba(255, 255, 255, 0.60)'
                                                }}>
                                                    {order.last_updated_at}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </Box>
                        <Box className={classes.itemInputBox}>
                            <div style={{ width: '100%' }}>
                                <div>
                                    <span>{t('transfer_to')}</span>
                                    <span style={{ marginLeft: 10 }}>{transferDriverName}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: 10 }}>
                                    <TextField
                                        variant="outlined"
                                        style={{ marginRight: 10 }}
                                        placeholder={t('driver_id')}
                                        onChange={(e) => {
                                            setTransferDriverName(handleTextualizeDriverNameAndVehicleType(e.target.value, userPref.userCity, driverListTemp, searchList));
                                            setTransferDriverId(e.target.value);
                                        }}
                                        value={transferDriverId}
                                        fullWidth
                                    />
                                    <Button
                                        variant='contained'
                                        color="secondary"
                                        onClick={handleSubmit}
                                        disabled={!transferDriverName || transferDriverName === '...'}
                                        id='driverdispatch-drivertransfer-return-button'
                                    >
                                        {t('submit')}
                                    </Button>
                                </div>
                            </div>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <FullscreenLoading open={loading} />
        </UniDialog>
    );
}
export default ReturnedPackages;